/** The recorded music, one seamless loop per file. GENERATED by
 * ~/Music/realm_music/export_game.py from loops/report.json - do not edit here.
 *
 * `loopSeconds` is the exact loop point. Each file carries one more second of
 * its own opening after it, so the wrap never depends on how a decoder pads
 * the tail of a Vorbis stream (ffmpeg and Chrome return a few hundred stray
 * samples there). Levelled to -16 LUFS integrated; peaks sit under -2 dBFS.
 */

export interface MusicTrackFile {
  /** File name under the app's `/music` route. */
  readonly file: string;
  /** Where the loop wraps back to 0, in seconds. */
  readonly loopSeconds: number;
}

export const MUSIC_TRACKS: Readonly<Record<string, MusicTrackFile>> = Object.freeze({
  blackwater: { file: "blackwater.ogg", loopSeconds: 6140043 / 44100 },
  frostmark: { file: "frostmark.ogg", loopSeconds: 6559875 / 44100 },
  sunspire: { file: "sunspire.ogg", loopSeconds: 6361425 / 44100 },
  prismgate: { file: "prismgate.ogg", loopSeconds: 6088446 / 44100 },
  saltreach: { file: "saltreach.ogg", loopSeconds: 6117111 / 44100 },
  deepvault: { file: "deepvault.ogg", loopSeconds: 6425370 / 44100 },
  cogworks: { file: "cogworks.ogg", loopSeconds: 6116670 / 44100 },
  fenmire: { file: "fenmire.ogg", loopSeconds: 6151950 / 44100 },
  emberpit: { file: "emberpit.ogg", loopSeconds: 6260832 / 44100 },
  gravewatch: { file: "gravewatch.ogg", loopSeconds: 6537825 / 44100 },
  overworld: { file: "overworld.ogg", loopSeconds: 6107850 / 44100 },
  overworld2: { file: "overworld2.ogg", loopSeconds: 6535620 / 44100 },
  overworld2b: { file: "overworld2b.ogg", loopSeconds: 5777100 / 44100 },
  greenmantle: { file: "greenmantle.ogg", loopSeconds: 6229125 / 44100 },
  ironhorde: { file: "ironhorde.ogg", loopSeconds: 6218100 / 44100 },
  skyreach: { file: "skyreach.ogg", loopSeconds: 5964525 / 44100 },
});
